
angular.module('impactx.vcatalog').controller('VCatalogFilterBridgeCtrl', VCatalogFilterBridgeController);
VCatalogFilterBridgeController.$inject = ['SearchFilter', 'SearchService'];
function VCatalogFilterBridgeController(SearchFilter, SearchService) {
    this.SearchFilter = SearchFilter;
    this.filterNeedsReset = {value: false};
    this.trns = SearchFilter.trns;
    this.onFilterChange = function () {
        return SearchService.searchAll();
    };
}

angular.module('impactx.vcatalog').controller('VCatalogCtrl', VCatalogController);
VCatalogController.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'searchFilter',
    'panelService',
    '$config',
    'RFXCreateService',
    'SearchService',
    'ToolbarService',
    'SearchFilterStorage',
    'SearchFilter',
    '$rootScope',
    '$location',
    'AppConfiguration',
    '$context',
    'OCICatalogService',
    'ProductViewService',
    'TranslationService',
    'ThemeWorldService',
    '$redirect',
    '$mdDialog',
    'ixaProductComparison'
];

function VCatalogController($scope, dataGen, $routeParams, searchFilter, panelService, $config, RFXCreateService,
                            SearchService, ToolbarService, SearchFilterStorage, SearchFilter, $rootScope, $location,
                            AppConfiguration, $context, OCICatalogService, ProductViewService, TranslationService,
                            ThemeWorldService, $redirect, $mdDialog, ixaProductComparison) {
    var vCatalogCtrl = this;
    vCatalogCtrl.getCatalogPanelColor = panelService.getCatalogPanelColor;
    var scrollPositionList = 0;
    this.translationService = TranslationService;
    this.panelsInitialized = false;
    this.showScrollTopButton = false;
    this.pageNumber = 1;
    this.informationIsOpen = SearchService.userSearchConfig('informationIsOpen');
    this.showPanelLabel = AppConfiguration.get('showPanelLabels');
    this.expandProductGroupDefault = SearchService.userSearchConfig('expandProductGroupDefault');
    ToolbarService.showSearchFilterToggle();
    this.id = $routeParams.id;
    this.prgId = $routeParams.prgId ? $routeParams.prgId : 0;
    this.filterNeedsReset = {value: false};
    this.SearchFilter = SearchFilter;
    vCatalogCtrl.searchWithReset = function (item) {
        vCatalogCtrl.filterNeedsReset.value = true;
        SearchFilter.setSearchInputClassification(null);
        var freshFilter = SearchFilterStorage.getFreshFilter();
        if (freshFilter) {
            vCatalogCtrl.filter = freshFilter;
            vCatalogCtrl.filter.vcatalogId = {value: $routeParams.id};
            vCatalogCtrl.filter.dialogFilter = "vcat" + ($routeParams.prgId ? ("_prg" + $routeParams.prgId) : "");
            vCatalogCtrl.filter.prgId = {value: $routeParams.prgId};
            SearchFilterStorage.setVCatFilter($routeParams.id, vCatalogCtrl.filter);
            vCatalogCtrl.filter.searchInput.value = searchFilter.searchInput;
            if (item) {
                if (item.isClassification) {
                    vCatalogCtrl.filter.guidingClassification.selected = {id: item.id, value: item.value};
                }
            }
            SearchFilter.setFilters(vCatalogCtrl.filter);
        }
        vCatalogCtrl.searchAll();
    }

    var currentLocation = $location.path();
    var backButtonUsed = $rootScope.location !== currentLocation;
    var storedSearchFilterObject = SearchFilterStorage.getVCatFilter($routeParams.id);
    if (storedSearchFilterObject && ($routeParams.useSetFilter || storedSearchFilterObject.searchInputUsed || storedSearchFilterObject.productGroupSelected ||  backButtonUsed ||
        ($rootScope.previousRoute.originalPath.indexOf("search.productgroup") > -1 &&
            $rootScope.previousRoute.params && $rootScope.previousRoute.params.id && $rootScope.previousRoute.params.id === $routeParams.id))) {
        storedSearchFilterObject.searchInputUsed = false;
        storedSearchFilterObject.productGroupSelected = false;
        vCatalogCtrl.filter = storedSearchFilterObject;
        vCatalogCtrl.filter.dialogFilter = "vcat"+ ($routeParams.prgId ? ("_prg" + $routeParams.prgId) : "");
        vCatalogCtrl.filter.prgId = {value: $routeParams.prgId};
        searchFilter.searchInput = vCatalogCtrl.filter.searchInput.value;
        var guidingClassification =  vCatalogCtrl.filter.guidingClassification;
        if (guidingClassification && guidingClassification.superEntries) {
            var superEntry = guidingClassification.superEntries[guidingClassification.superEntries.length - 1];
            SearchFilter.setSearchInputClassification(superEntry);
        }
        else {
            SearchFilter.setSearchInputClassification(null);
        }
        if(!vCatalogCtrl.filter.productsPerPage)
        {
            vCatalogCtrl.filter.productsPerPage = SearchService.getNumberOfProductRows();
        }
        SearchFilter.setFilters(vCatalogCtrl.filter);
        getVCatalogData(backButtonUsed);
    }
    else {
        SearchFilter.setSearchInputClassification(null);
        var freshFilter = SearchFilterStorage.getFreshFilter();
        if (freshFilter) {
            vCatalogCtrl.filter = freshFilter;
            vCatalogCtrl.filter.vcatalogId = {value: $routeParams.id};
            vCatalogCtrl.filter.dialogFilter = "vcat"+ ($routeParams.prgId ? ("_prg" + $routeParams.prgId) : "");
            vCatalogCtrl.filter.prgId = {value: $routeParams.prgId};
            SearchFilterStorage.setVCatFilter($routeParams.id, vCatalogCtrl.filter);
            searchFilter.searchInput = vCatalogCtrl.filter.searchInput.value;
            SearchFilter.setFilters(vCatalogCtrl.filter);
            getVCatalogData();
        }
        else {
            var result = {};
            dataGen.getData(result, {}, "/search/filter", null, true).then(function () {
                SearchFilterStorage.setFreshFilter(result.data);
                vCatalogCtrl.filter = result.data;
                vCatalogCtrl.filter.vcatalogId = {value: $routeParams.id};
                vCatalogCtrl.filter.dialogFilter = "vcat" + ($routeParams.prgId ? ("_prg" + $routeParams.prgId) : "");
                vCatalogCtrl.filter.prgId = {value: $routeParams.prgId};
                SearchFilterStorage.setVCatFilter($routeParams.id, vCatalogCtrl.filter);
                if ($location.path() === currentLocation) {
                    //only if we are still on the vCatalog page.
                    searchFilter.searchInput = vCatalogCtrl.filter.searchInput.value;
                    SearchFilter.setFilters(vCatalogCtrl.filter);
                    getVCatalogData();
                }
            });
        }
    }

    function getVCatalogData(backButtonUsed)
    {
        return dataGen.getData($scope, {id: $routeParams.id, prgId: $routeParams.prgId}, "/vcatalog/view", function () {
            if ($scope.data.catalog && $scope.data.catalog.doBackgroundSearch && !$scope.data.catalog.isUnite) {
                ToolbarService.hideSearchFilterToggle();
            }
            vCatalogCtrl.searchAll(true).then(function () {
                vCatalogCtrl.panelsInitialized = true;
                if(backButtonUsed) {
                    SearchFilterStorage.scrollToSearchScrollPosition("vcat", '#search-view');
                }
            });
            $scope.no_result = $scope.data.noResultsInThemeWorld;
            $scope.data.suppliers = [$scope.data.supplier];
            if ($scope.data.suppliers && $scope.data.suppliers.length == 1) {
                $scope.trns.suppliers = $scope.trns.supplier;
            }
            if ($scope.data.lots && $scope.data.lots.length == 1) {
                $scope.trns.lots = $scope.trns.lot;
            }
            if (!$scope.data.isOriginalCatalog) {
                vCatalogCtrl.informationIsOpen = true;
            }
            $scope.trns.addToThemeWorld = TranslationService.get('addToThemeWorld');
            $scope.trns.removeFromThemeWorld = TranslationService.get('removeFromThemeWorld');
            $scope.trns.addToProductView = TranslationService.get('addToProductView');
            $scope.trns.removeFromProductView = TranslationService.get('removeFromProductView');
            $scope.trns.showAll = TranslationService.get("showAll");

            defineButtons();
        });
    }

    $scope.$on('$routeChangeStart', function (event, newRoute, oldRoute) {
        var detailList = newRoute.originalPath.indexOf("/search.") > - 1;
        if (!detailList && newRoute.originalPath !== "/search") {
            SearchFilter.setSearchInputClassification(null);
            searchFilter.searchInput = "";
            SearchFilter.setFilters(SearchFilterStorage.getFreshFilter());
        }
        if (newRoute.$$route.originalPath !== oldRoute.$$route.originalPath) {
            SearchFilterStorage.setSearchFilterPlaceHolder(null);
            SearchFilterStorage.setSearchScrollPosition("vcat", document.getElementById('search-view').scrollTop);
        }
    });

    vCatalogCtrl.createScrollList = function () {
        $scope.scrollList = [];
        var numberOfPros = vCatalogCtrl.numberOfProducts;

        if (numberOfPros > 1) {
            $scope.scrollList.push({id: "pro", label: numberOfPros + " " + $scope.trns.products})
        }
        if (numberOfPros === 1) {
            $scope.scrollList.push({id: "pro", label: numberOfPros + " " + $scope.trns.product})
        }
        if ($scope.scrollList.length > 0) {
            $scope.scrollList.unshift({id: "header", label: $scope.trns.headerData, func: openHeaderArea});
        }

        ToolbarService.setScrollMenu($scope.scrollList);
    };

    vCatalogCtrl.toExternalCat = function () {
        if ($scope.data.catalog && $scope.data.catalog.isExternal) {
            OCICatalogService.toExternalCat($scope.data.catalog);
        }
    };

    vCatalogCtrl.backgroundSearch = function () {
        SearchService.lastSearchInput = SearchFilter.getFilters().searchInput.value;
        return dataGen.postAsForm({}, {query: SearchFilter.getFilters().searchInput.value,
            drillDowns: $scope.data.catalog.isUnite ? SearchFilter.getFilters().drillDowns : null,
            pageNumber: SearchFilter.getFilters().productPageNumber,
            priceRange: $scope.data.catalog.isUnite ? SearchFilter.getFilters().priceRange : null,
            productsPerPage: SearchService.getNumberOfProductRows(),
            sort: $scope.data.catalog.isUnite ? SearchFilter.getFilters().sort : null,
            catId: $scope.data.catalog.id}, "/search/oci/background", null, false).then(function (response) {
            vCatalogCtrl.trns = response.trns;
            response.data.numberOfProducts = response.data.numOfProducts;
            if ($scope.data.catalog.isUnite) {
                var facets = impactX.isDefined(response, 'data.attributeSearch.facetResults');
                SearchFilter.setFacets(facets ? facets : []);
                var drillDowns = impactX.isDefined(response, 'data.attributeSearch.drillDowns');
                SearchFilter.getFilters().drillDowns = drillDowns ? drillDowns : [];
            }
            angular.extend(vCatalogCtrl, response.data);
            vCatalogCtrl.createScrollList();
            $scope.noResultsFromBackgroundSearch = SearchFilter.getFilters().searchInput.value ? response.data.products.length === 0 : false;
        });
    };

    vCatalogCtrl.createRFX = function () {
        RFXCreateService.createRFX("vcat", $routeParams.id);
    };

    vCatalogCtrl.showScrollTop = function (showScrollTop, scrollPosition) {
        vCatalogCtrl.showScrollTopButton = showScrollTop;
        scrollPositionList = scrollPosition;
    };

    vCatalogCtrl.searchProducts = function (index, selectedSort) {
        vCatalogCtrl.filter.productPageNumber = index;
        vCatalogCtrl.filter.productsPerPage = SearchService.getNumberOfProductRows();
        if (selectedSort)
        {
            vCatalogCtrl.filter.sort.selected = selectedSort;
        }
        if ($scope.data.catalog && $scope.data.catalog.doBackgroundSearch) {
            return vCatalogCtrl.backgroundSearch();
        }
        else {
            return SearchService.searchProducts(vCatalogCtrl.filter.productPageNumber).then(function (searchResults) {
                if (searchResults) {
                    angular.extend(vCatalogCtrl, searchResults);
                }
            })
        }
    };

    vCatalogCtrl.searchAll = function (onInit) {
        if (!onInit && vCatalogCtrl.filter) {
            vCatalogCtrl.filter.productPageNumber = 1;
        }
        if ($scope.data.catalog && $scope.data.catalog.doBackgroundSearch) {
            return vCatalogCtrl.backgroundSearch();
        }
        else {
            return SearchService.searchAll().then(function (searchResult) {
                angular.extend(vCatalogCtrl, searchResult);
                vCatalogCtrl.createScrollList();
                $scope.noSearchResults = searchResult.catalogs.length === 0 && (!searchResult.lots || searchResult.lots.length === 0) && searchResult.products.length === 0;
                $scope.no_result = $scope.themeWorldActive && $scope.noSearchResults;
            });
        }
    };

    vCatalogCtrl.scrollToTop = function () {
        angular.element('#search-view').animate({
            scrollTop: scrollPositionList
        }, 200);
    };

    vCatalogCtrl.toggleInformation = function () {
        vCatalogCtrl.informationIsOpen = !vCatalogCtrl.informationIsOpen
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.createRFX,
                action: vCatalogCtrl.createRFX,
                type: 'dialogaction',
                condition: vCatalogCtrl.canCreateRFX
            },
            {
                label: $scope.trns.ociredirect,
                action: vCatalogCtrl.toExternalCat,
                type: 'dialogaction',
                condition: canJumpToExternalCat
            },
            {
                labelFunction: function (){return ixaProductComparison.getRedirectButtonLabel()},
                linkFunction: function ()
                {
                    return "productcomparison"
                },
                type: 'link',
                condition: function ()
                {
                    return ixaProductComparison.getProductComparisonCount() > 1
                }
            },
            {
                label: $scope.trns.addToProductView,
                action: vCatalogCtrl.addToProductView,
                type: 'dialogaction',
                condition: canAddToProductView
            },
            {
                label: $scope.trns.removeFromProductView,
                action: vCatalogCtrl.removeFromProductView,
                type: 'dialogaction',
                condition: canRemoveFromProductView
            },
            {
                label: $scope.trns.addToThemeWorld,
                action: vCatalogCtrl.addToThemeWorld,
                type: 'dialogaction',
                condition: canAddToThemeWorld
            },
            {
                label: $scope.trns.removeFromThemeWorld,
                action: vCatalogCtrl.removeFromThemeWorld,
                type: 'dialogaction',
                condition: canRemoveFromThemeWorld
            },
            {
                label: $scope.trns.asExcel,
                action: vCatalogCtrl.exportExcel,
                type: 'dialogaction',
                process: 'VCatalogExcelExport'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canAddToProductView() {
        return $scope.data.canAddToProductView;
    }

    function canRemoveFromProductView() {
        return $scope.data.canRemoveFromProductView;
    }

    function canAddToThemeWorld() {
        return $scope.data.canAddToThemeWorld;
    }

    function canRemoveFromThemeWorld() {
        return $scope.data.canRemoveFromThemeWorld;
    }

    vCatalogCtrl.addToProductView = function($event) {
        $scope.data.canAddToProductView = false;
        $scope.data.canRemoveFromProductView = true;
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.addVCatsToProductView([$scope.data]);
    };

    vCatalogCtrl.removeFromProductView = function($event) {
        var vcatIds = [];
        $scope.data.canAddToProductView = true;
        $scope.data.canRemoveFromProductView = false;
        vcatIds.push($scope.data.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.removeVCatsFromProductView($context.hasActiveProductView.id, vcatIds);
    };

    vCatalogCtrl.addToThemeWorld = function($event) {
        $scope.data.canAddToThemeWorld = false;
        $scope.data.canRemoveFromThemeWorld = true;
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.addVCatsToThemeWorld([$scope.data]);
    };

    vCatalogCtrl.removeFromThemeWorld = function($event) {
        var vcatIds = [];
        $scope.data.canAddToThemeWorld = true;
        $scope.data.canRemoveFromThemeWorld = false;
        vcatIds.push($scope.data.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.removeVCatsFromThemeWorld($context.hasActiveThemeWorld.id, vcatIds);
    };

    vCatalogCtrl.exportExcel = function (event) {
        $mdDialog.show({
            templateUrl: 'modules/vcatalog/templates/vcatalog.exportsettings.html',
            controller: "VCatalogExportSettingsCtrl",
            controllerAs: "vCatalogExportSettingsCtrl",
            targetEvent: event,
            clickOutsideToClose: true,
            escapeToClose: false,
            bindToController: true,
            locals: {
                optionsEntrypoint: '/vcatalog/exportoneview',
                exportEntrypoint: '/vcatalog/exportone',
                vcatId: $routeParams.id
            }
        }).then(function () {

        });
    }

    this.canCreateRFX = function () {
        return $scope.data.showRFXButton;
    }

    function canJumpToExternalCat() {
        return $scope.data && $scope.data.catalog && $scope.data.catalog.isExternal;
    }

    function openHeaderArea() {
        vCatalogCtrl.informationIsOpen = true;
    }

    $scope.$on('$destroy', function () {
        SearchService.setUserSearchConfigParameter('expandProductGroupDefault', vCatalogCtrl.expandProductGroupDefault);
        SearchService.setUserSearchConfigParameter('informationIsOpen', vCatalogCtrl.informationIsOpen);
        ToolbarService.hideSearchFilterToggle();
    });

    $scope.$on('MainSearchTriggered', function () {
        vCatalogCtrl.informationIsOpen = false;
    });

    this.filterProductGroup = function(productGroup) {
        SearchFilter.filterProductGroup(productGroup, searchFilter);
    };

    this.redirectToVCat = function() {
        vCatalogCtrl.filterProductGroup({id: 0, vCatId: $routeParams.id}, searchFilter);
    };

    this.showNoResultsHint = function () {
        return !$context.hasActiveThemeWorldSearch || !$context.hasActiveThemeWorldSearch.value;
    }

    this.redirectToContacts = function () {
        $redirect.redirectTo(null, "search.contact/vcat/" + $routeParams.id);
    }

    this.searchTerm = function (term) {
        SearchFilter.setFilterIdentifier();
        searchFilter.searchInput = term;

        SearchFilter.setFilters(SearchFilterStorage.getFreshFilter())

        SearchFilter.getFilters().vcatalogId = {value: $routeParams.id};
        SearchFilter.getFilters().dialogFilter = "vcat";
        SearchFilterStorage.setVCatFilter($routeParams.id, SearchFilter.getFilters());

        searchFilter.resetDetailFilter().then(function () {
            var filterData = {};
            if ($context.hasActiveShopView.value) {
                searchFilter.listSearch.value = true;
            }
            SearchFilter.getFilters().searchInput.value = searchFilter.searchInput;
            SearchFilter.getFilters().searchInputUsed = true;
            vCatalogCtrl.searchWithReset();
        });
    };
}
